import { render, staticRenderFns } from "./ListFrame.vue?vue&type=template&id=4952dc47&"
import script from "./ListFrame.vue?vue&type=script&lang=js&"
export * from "./ListFrame.vue?vue&type=script&lang=js&"
import style0 from "./ListFrame.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VContent } from 'vuetify/lib/components/VContent';
installComponents(component, {VApp,VAppBar,VContent})
